import React from "react";
import Box from "@mui/material/Box";
import {
	DataGrid,
	GridToolbar,
	GridToolbarExport,
} from "@mui/x-data-grid";
import { Paper } from "@mui/material";
import { motion } from "framer-motion";

const Table = (props) => {
	const { columns, idVisible, rows, isOfferings, width } = props;

	return (
		<motion.div
			initial={{ opacity: 0, x: -100 }}
			animate={{ opacity: 1, x: 0 }}
			transition={{ duration: 0.6, ease: "easeOut" }}
		>
			<Paper
				elevation={1}
				sx={{
					p: 3,
					borderRadius: "12px",
					width: "100%",
					boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
				}}
			>
				<Box sx={{ height: "70vh", width: width ? width : "100%" }}>
					<DataGrid
						columnVisibilityModel={{
							id: idVisible ? true : idVisible,
						}}
						rowHeight={35}
						pageSize={10}
						rowsPerPageOptions={[10]}
						components={{
							Toolbar: () => (
								<GridToolbar>
									<GridToolbarExport />
								</GridToolbar>
							),
						}}
						rows={rows}
						columns={columns}
						initialState={{ pinnedColumns: { right: ["actions"] } }}
						getRowClassName={(params) => {
							if (!isOfferings) return "";
							return params.row.expiringSoon ? "highlight" : "";
						}}
						sx={{
							"& .MuiDataGrid-root": {
								borderRadius: "12px",
							},
							"& .MuiDataGrid-iconSeparator": {
								display: "none",
							},
							"& .MuiDataGrid-columnHeaders": {
								backgroundColor: "#1976d2",  // blue header
								color: "#fff",               // white text
								fontSize: "1rem",
								fontWeight: "bold",
							},
							"& .MuiDataGrid-pinnedColumnHeaders": {
								boxShadow: "none",
								backgroundColor: "transparent",
							},
							"& .MuiDataGrid-pinnedColumns": {
								boxShadow: "none",
								backgroundColor: "transparent",
								"& .MuiDataGrid-cell": {
									padding: 0,
								},
							},
							"& .MuiDataGrid-row": {
								cursor: "pointer",
								transition: "background-color 0.3s ease",
								"&:hover": {
									backgroundColor: isOfferings ? "" : "#f5f5f5",
								},
								"&:first-child": {
									borderTop: "1px solid rgba(224, 224, 224, 1)",
								},
							},
							"& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
								outline: "none",
							},
							"& .MuiDataGrid-columnHeaders": {
								backgroundColor: "#f0f2f5",
								fontWeight: "bold",
								fontSize: "14px",
							},
							"& .MuiDataGrid-toolbarContainer": {
								padding: "8px",
								backgroundColor: "#fafafa",
								borderRadius: "8px",
								marginBottom: "10px",
							},
							".highlight": {
								bgcolor: "#f96d6d",
								color: "black",
								"&:hover": {
									backgroundColor: "#f96d6d",
									color: "black",
								},
							},
						}}
					/>
				</Box>
			</Paper>
		</motion.div>
	);
};

export default Table;
